import { IChartDataSet } from '../../../../../../Contracts/chart/IChartDataSet';
import {
    IComboChartData,
    IComboChartDataSet
} from '../ComboChart/IComboChartData';
import { IDoubleColumnChartData } from './IDoubleColumnChartData';

const monthMap = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

function formatMonthYear(label: any): string {
    let month = "";
    let year = "";

    if (Array.isArray(label)) {
        [month, year] = label;
    } else if (typeof label === "string") {
        const parts = label.split(/[-\n/]/);
        [month, year] = parts;
    }

    const monthIndex = parseInt(month) - 1;
    const shortMonth = monthMap[monthIndex] || month;
    const shortYear = year?.slice(-2) || "";

    return `${shortMonth}-${shortYear}`;
}

export const processDoubleColumnChartData = (inputData: IDoubleColumnChartData | IComboChartData, isEEPlanTracking:boolean): Array<Array<any>> => {
    if (inputData == null) return [[]];
    if (inputData.labels == null) return [[]];
    if (inputData.datasets == null) return [[]];
    let processedData: Array<Array<any>> = [[]];
    let labelList: Array<string> = [];
    processedData[0].push("Category");

    if (isEEPlanTracking){
        inputData.labels.forEach((label: any) => {
            const finalLabel = formatMonthYear(label);
            processedData.push([finalLabel]);
        });

        inputData.labels.forEach((label: any) => {
            const finalLabel = formatMonthYear(label);
            labelList.push(finalLabel);
        });
    }
    else{
        inputData.labels.forEach(function (label) {
            let finalLabel = label[0];
            if (label.length > 1) {
                for (var i = 1; i < label.length; i++) {
                    if (finalLabel.length > (160 / inputData.labels.length)) {
                        finalLabel = finalLabel + "...";
                        break;
                    }
                    finalLabel = finalLabel + "\n" + label[i];
                }
            }
            processedData.push([finalLabel]);
        });

        inputData.labels.forEach(function (label) {
            let finalLabel = label[0];
            if (label.length > 1) {
                for (var i = 1; i < label.length; i++) {
                    finalLabel = finalLabel + " " + label[i];
                }
            }
            labelList.push(finalLabel);
        });
    }

    inputData.datasets.forEach(function (dataset: IChartDataSet | IComboChartDataSet) {
        processedData[0].push(dataset.label);
        dataset.data.forEach(function (data, index) {
            const displayText = inputData.valueFormatter != null ? inputData.valueFormatter(data.toString()) : data;
            const customTooltip = inputData.customTooltips != null ? inputData.customTooltips : null;

            let valueObject =
            {
                v: data,
                f: customTooltip != null ? displayText + "\n" + customTooltip[index] : displayText,
                originalLabel: labelList[index] || ''
            };

            if (Array.isArray(processedData[index + 1])) {
                processedData[index + 1].push(valueObject);
            } else {
                processedData[index + 1] = [valueObject];
            }
        });
    });


    return processedData;
};
